import {
    Button,
    Container,
    Grid,
    MenuItem,
    CircularProgress,
    Paper,
    Box
} from '@material-ui/core';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';
import {
    RefundAllProviderPenidng as REFUND_ALL_PENDING_PROVIDER,
    UpdateStatusManuallyPenidngProvider as STATUS_UPDATE,
    ShiftAll as SHIFT_ALL,
    SuccessAllProviderPenidng as SUCCESS_ALL_PENDING_PROVIDER
} from 'Components/Api/TransactionAPI';
import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import { SelectByPrimeServices as SERVICE_SELECT_PRIME } from 'Components/Api/ServiceApi';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { SelectPendingProvider as SELECT_PENDING_PROVIDER_TRANSACTION } from 'Components/Api/TransactionReportAPI';
import FormHeader from 'Components/FormHeader';
import { MaterialAlphaNumberField } from 'Components/Inputes/FormikMaterialAlphaNumberInput';
import { MESSAGE_CLOSE_AFTER } from 'Components/Helper/Messages';
import excel from 'Assets/Images/excel.svg';
import HOCLoader from 'Components/Loader/HOCLoader';
import { CustomModal } from 'Components/Modal/CustomModal';
import { ProviderModal } from 'Components/Modal/ProviderModel';
import ReactTable from 'Components/ReactTable/ReactTable';
import { LOGOUT } from 'ConstComponents';
import { SelectByIDLog } from 'Pages/InnerPages/Report/LogByTransactionMasterID';
import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form } from 'formik';
import Icon from '@material-ui/core/Icon';
import { HeaderPendingSummary } from 'Components/SummaryCards/HeaderPendingSummary';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

const CustomContainer = HOCLoader(Container);

export const PendingProviderRecharge = () => {
    const classes = commonStyle();
    const [itemList, setItemList] = useState([]);
    const [Services, setServices] = useState([]);
    const [headerSummary, setHeaderSummary] = useState({});
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [modalErrorMessage] = useState('');
    const [mainColumns, setMainColumns] = useState([]);

    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [responseMessage, setResponseMessage] = useState('');

    const [consumerNumber, setConsumerNumber] = useState(0);
    const [Amount, setAmount] = useState(0);
    const [TransactionID, setTransactionMasterID] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAlertOpenRefund, setIsAlertOpenRefund] = useState(false);
    const [isAlertOpenRefundAll, setIsAlertOpenRefundAll] = useState(false);
    const [isAlertOpenSuccessAll, setIsAlertOpenSuccessAll] = useState(false);
    const [transactionsForShift, setTransactionsForShift] = useState([]);
    const [openProviderForShiftAll, setOpenProviderForShiftAll] = useState(
        false
    );
    const [isAlertOpenSuccess, setIsAlertOpenSuccess] = useState(false);

    const [
        shouldGetUpdatedDataFromTable,
        setShouldGetUpdatedDataFromTable
    ] = useState(false);

    const [isRefundAllClicked, setIsRefundAllClicked] = useState(false);
    const [isShiftAllClicked, setIsShiftAllClicked] = useState(false);
    const [isSuccessAllClicked, setIsSuccessAllClicked] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const formRef = useRef();
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [TakeCount, setTakeCount] = useState(10);
    const [SkipCount, setSkipCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);

    const [operators, setOperators] = useState([]);

    const SelectPending = async () => {
        let requestObj = {
            OperatorID: 0,
            ConsumerNumber: '',
            ServiceID: 0
        };

        var requestJSON = JSON.stringify(requestObj);
        setLoadingOpen(true);
        const response = await SELECT_PENDING_PROVIDER_TRANSACTION(requestJSON);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }

        let d = JSON.parse(response.data);
        setHeaderSummary(d.HeaderSummary);
        setItemList(d.list);
        setLoadingOpen(false);
    };

    const SelectPendingRechargeWithFilter = async (values) => {
        setItemList([]);
        setLoadingOpen(true);
        const {
            isAuthorized,
            status,
            data
        } = await SELECT_PENDING_PROVIDER_TRANSACTION(JSON.stringify(values));

        setLoadingOpen(false);

        if (!isAuthorized) LOGOUT();

        if (!status) {
            setResponseMessage(data);
            setSeverity('error');
            setIsError(true);
            return;
        }

        let d = JSON.parse(data);

        setHeaderSummary(d.HeaderSummary);
        setItemList(d.list);
    };

    const StatusUpdate = async (request) => {
        let jsonObj = {
            TransactionMasterID: request.TransactionMasterID,
            ReferenceNo: request.TxnID,
            Pin: request.Pin,
            Status: request.BtnTitle
        };

        let requestJson = JSON.stringify(jsonObj);

        setIsError(false);
        setLoadingOpen(true);
        const { isAuthorized, status, data } = await STATUS_UPDATE(requestJson);

        setLoadingOpen(false);

        if (!isAuthorized) LOGOUT();

        setResponseMessage(data);

        if (!status) {
            setSeverity('error');
            setIsError(true);
        }
        setSeverity('success');
        setIsError(true);

        SelectPending();
    };

    const callSelectData = async (
        TakeCount,
        SkipCount,
        SearchText,
        SortColumnName,
        SortDirection
    ) => {
        let requestObj = {
            TakeCount: TakeCount,
            SkipCount: SkipCount,
            Search: SearchText,
            SortColumnName: SortColumnName,
            OperatorID: formRef.current.values.OperatorID,
            ServiceID: formRef.current.values.ServiceID,
            ConsumerNumber: formRef.current.values.ConsumerNumber,
            IsExcelDownload: formRef.current.values.IsExcelDownload
        };
        //if (formRef.current.values.IsExcelDownload === false) setTransactions();

        if (SkipCount <= 0) {
            setHeaderSummary({});
        }
        setIsError(false);
        setLoading(true);

        var requestJSON = JSON.stringify(requestObj);

        const response = await SELECT_PENDING_PROVIDER_TRANSACTION(requestJSON);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');

            setResponseMessage(response.data);
            return;
        }
        setSeverity('success');

        var d = JSON.parse(response.data);

        if (d.IsExcelDownload) {
            downloadFile(d.ReportPath, 'Pending_Provider_Recharge');
            return;
        }
        if (SkipCount <= 0) {
            setHeaderSummary(d.HeaderSummary);

            setTotalCount(d.Count);
        }

        setItemList(d.list);
    };

    function downloadFile(URL, Title) {
        let a = document.createElement('a');
        a.href = URL;
        a.setAttribute('download', Title);
        a.setAttribute('target', '_blank');
        a.click();
        document.removeChild(a);
    }

    const logClick = async (request, ConsumerNumber, Amount) => {
        setIsModalOpen(true);
        setTransactionMasterID(request);
        setConsumerNumber(ConsumerNumber);
        setAmount(Amount);
    };

    const createColumns = () => {
        let columns = [];

        columns.push({
            label: '#',
            name: 'TransactionMasterID',
            srno: true
        });

        columns.push({
            label: 'Date',
            name: 'DOC'
        });

        columns.push({
            label: 'Name',
            name: 'FirmName'
        });
        columns.push({
            label: 'Number',
            name: 'ConsumerNumber'
        });

        columns.push({
            label: 'Operator',
            name: 'OperatorName'
        });

        columns.push({
            label: 'Amount',
            name: 'Amount'
        });

        columns.push({
            label: 'Success/Refund',
            name: 'TransactionMasterID',
            CustomSuccessFail: true,
            callback: (TransactionMasterID, TxnID, Pin, BtnTitle) => {
                StatusUpdateClick(TransactionMasterID, TxnID, Pin, BtnTitle);
            }
        });
        columns.push({
            label: '',
            name: 'TransactionMasterID',
            hide: true
        });

        columns.push({
            label: 'Provider',
            name: 'ProviderName'
        });
        columns.push({
            label: 'ProviderRequestID',
            name: 'ProviderRequestID'
        });
        columns.push({
            label: 'Param1',
            name: 'AdditionalParam1'
        });
        columns.push({
            label: 'Param2',
            name: 'AdditionalParam2'
        });
        columns.push({
            label: 'Log',
            name: 'TransactionMasterID',
            buttonTitle: 'Log',
            testbutton: true,
            callback: (value, row) => {
                logClick(value, row[3], row[6]);
            }
        });

        setMainColumns(columns);
    };

    const StatusUpdateClick = (TransactionMasterID, TxnID, Pin, BtnTitle) => {
        if (!TxnID && BtnTitle === 'SUCCESS') {
            setIsError(true);
            setResponseMessage('Please enter valid transaction id');
            setSeverity('error');
            return;
        }
        let RequestObj = {
            TransactionMasterID: TransactionMasterID,
            TxnID: TxnID,
            Pin: Pin,
            BtnTitle: BtnTitle
        };
        if (BtnTitle === 'REFUND') setIsAlertOpenRefund(true);
        if (BtnTitle === 'SUCCESS') setIsAlertOpenSuccess(true);
        setConfirmAlertRequest(RequestObj);
    };
    const ShiftAll = async (providerID) => {
        let requestArr = transactionsForShift;
        let request = [];
        requestArr.forEach((element) => {
            let { value } = element[0];
            request.push({
                TransactionMasterID: value,
                IsStatusCheck: false,
                ProviderID: providerID
            });
        });
        setLoadingOpen(true);
        let { isAuthorized, status, data } = await SHIFT_ALL(
            JSON.stringify(request)
        );
        setLoadingOpen(false);

        if (!isAuthorized) LOGOUT();

        setResponseMessage(data);

        if (!status) {
            setSeverity('error');
            setIsError(true);
            return;
        }
        setSeverity('success');
        setIsError(true);
        setTimeout(() => {
            SelectPending();
        }, MESSAGE_CLOSE_AFTER);
    };

    useEffect(() => {
        createColumns();
        selectServices();
        SelectPending();
    }, []);

    const ProcessUpdatedData = (data) => {
        setShouldGetUpdatedDataFromTable(false);

        if (isSuccessAllClicked) {
            setIsAlertOpenSuccessAll(true);
            setConfirmAlertRequest(data);
            return;
        }

        if (isRefundAllClicked) {
            setIsAlertOpenRefundAll(true);
            setConfirmAlertRequest(data);
            return;
        }
        if (isShiftAllClicked) {
            setIsAlertOpenRefundAll(false);
            setIsShiftAllClicked(true);
            ShiftAllClick(data);
            return;
        }
    };

    const SuccessAll = async (requestArr) => {
        setIsSuccessAllClicked(false);
        if (requestArr.length <= 0) {
            setSeverity('error');
            setResponseMessage(
                'Please select one or more transactions to success'
            );
            setIsError(true);
            return;
        }
        let request = [];

        requestArr.forEach((element) => {
            let { value } = element[0];
            request.push({ ID: value });
        });

        setLoadingOpen(true);

        let { isAuthorized, status, data } = await SUCCESS_ALL_PENDING_PROVIDER(
            JSON.stringify(request)
        );
        setLoadingOpen(false);

        if (!isAuthorized) LOGOUT();

        setResponseMessage(data);

        if (!status) {
            setSeverity('error');
            setIsError(true);
            return;
        }
        setSeverity('success');
        setIsError(true);
        SelectPending();
    };

    const RefundAll = async (requestArr) => {
        setIsRefundAllClicked(false);
        if (requestArr.length <= 0) {
            setSeverity('error');
            setResponseMessage(
                'Please select one or more transactions to refund'
            );
            setIsError(true);
            return;
        }
        let request = [];

        requestArr.forEach((element) => {
            let { value } = element[0];
            request.push({ ID: value });
        });

        setLoadingOpen(true);

        let { isAuthorized, status, data } = await REFUND_ALL_PENDING_PROVIDER(
            JSON.stringify(request)
        );
        setLoadingOpen(false);

        if (!isAuthorized) LOGOUT();

        setResponseMessage(data);

        if (!status) {
            setSeverity('error');
            setIsError(true);
            return;
        }
        setSeverity('success');
        setIsError(true);
        setTimeout(() => {
            SelectPending();
        }, MESSAGE_CLOSE_AFTER);
    };
    const ShiftAllClick = (requestArr) => {
        setIsShiftAllClicked(false);
        if (requestArr.length <= 0) {
            setSeverity('error');
            setResponseMessage(
                'Please select one or more transactions to shift'
            );
            setIsError(true);
            return;
        }
        setTransactionsForShift(requestArr);
        setOpenProviderForShiftAll(true);
    };
    const PendingRechargeList = (
        <ReactTable
            data={itemList}
            columns={mainColumns}
            count={totalCount}
            rowsPerPage={TakeCount}
            headerToolbar={false}
            SuccessFailHeader={true}
            primaryIndex={12}
            getCallback={({ currentPage, RowsPerPage }) => {
                setCurrentPage(currentPage);
                setTakeCount(RowsPerPage);
                setSkipCount(RowsPerPage * currentPage);
                callSelectData(
                    RowsPerPage,
                    RowsPerPage * currentPage,
                    '',
                    '',
                    ''
                );
            }}
            setLoadingOpen={(value) => {
                setLoadingOpen(value);
            }}
            setIsError={(value) => {
                setIsError(value);
            }}
            setSeverity={(value) => {
                setSeverity(value);
                SelectPending();
            }}
            setResponseMessage={(value) => {
                setResponseMessage(value);
                SelectPending();
            }}
            getUpdatedData={(data) => {
                ProcessUpdatedData(data);
                setShouldGetUpdatedDataFromTable(false);
            }}
            shouldGetUpdatedData={shouldGetUpdatedDataFromTable}
            isSelectableRows={'multiple'}
        />
    );
    const ShiftAllForm = (
        <ProviderModal
            isOpen={openProviderForShiftAll}
            title="Shift"
            error={modalErrorMessage}
            submitCallback={(value) => {
                let { ProviderID } = value;
                setOpenProviderForShiftAll(false);
                ShiftAll(ProviderID);
            }}
            resendCallback={(value) => {}}
            onDismissCallback={(value) => {
                setOpenProviderForShiftAll(value);
            }}
        />
    );

    const APILogModal = (
        <CustomModal
            isOpen={isModalOpen}
            title="API Log"
            width="75%"
            onDismissCallback={(value) => {
                setIsModalOpen(value);
            }}
        >
            <SelectByIDLog
                TransactionMasterID={TransactionID}
                ConsumerNumber={consumerNumber}
                Amount={Amount}
                setLoading={(value) => setLoadingOpen(value)}
            />
        </CustomModal>
    );
    const RefundConfirmation = (
        <ConfirmAlert
            isOpen={isAlertOpenRefund}
            title="Refund Confirmation"
            message="Are you sure to refund this transaction?"
            request={confirmAlertRequest}
            positiveButtonClick={(request) => {
                setIsAlertOpenRefund(false);
                StatusUpdate(request);
            }}
            negativeButtonClick={() => {
                setIsAlertOpenRefund(false);
            }}
        />
    );
    const RefundAllConfirmation = (
        <ConfirmAlert
            isOpen={isAlertOpenRefundAll}
            title="Refund Confirmation"
            message="Are you sure to refund this selected ?"
            request={confirmAlertRequest}
            positiveButtonClick={(request) => {
                setIsAlertOpenRefundAll(false);
                RefundAll(request);
            }}
            negativeButtonClick={() => {
                setIsAlertOpenRefundAll(false);
            }}
        />
    );
    const SuccessAllConfirmation = (
        <ConfirmAlert
            isOpen={isAlertOpenSuccessAll}
            title="Success Confirmation"
            message="Are you sure to success this selected ?"
            request={confirmAlertRequest}
            positiveButtonClick={(request) => {
                setIsAlertOpenSuccessAll(false);
                SuccessAll(request);
            }}
            negativeButtonClick={() => {
                setIsAlertOpenRefundAll(false);
            }}
        />
    );

    const SuccessConfirmation = (
        <ConfirmAlert
            isOpen={isAlertOpenSuccess}
            title="Success Confirmation"
            message="Are you sure to success this transaction?"
            request={confirmAlertRequest}
            positiveButtonClick={(request) => {
                setIsAlertOpenSuccess(false);
                StatusUpdate(request);
            }}
            negativeButtonClick={() => {
                setIsAlertOpenSuccess(false);
            }}
        />
    );

    const CustomContainerCloseCallback = (alertState) => {
        setIsError(alertState);
    };

    const handleRefundAllClick = (e) => {
        setShouldGetUpdatedDataFromTable(true);
        setIsRefundAllClicked(true);
    };
    const handleShiftAllClick = (e) => {
        setShouldGetUpdatedDataFromTable(true);
        setIsShiftAllClicked(true);
    };
    const handleSuccessAllClick = (e) => {
        setShouldGetUpdatedDataFromTable(true);
        setIsSuccessAllClicked(true);
    };

    const selectServices = async () => {
        const response = await SERVICE_SELECT_PRIME();
        if (!response.isAuthorized) LOGOUT();

        var data = JSON.parse(response.data);
        setServices(data);
    };

    const OnOperatorChange = async (name, value, setFieldValue) => {
        var ServiceID = value; //event.target.value;

        setFieldValue(name, value);

        selectOperator(ServiceID);
    };

    const selectOperator = async (ServiceID) => {
        if (
            ServiceID === null ||
            ServiceID === undefined ||
            ServiceID === 0 ||
            ServiceID === '0'
        )
            return;
        var requestObj = {
            ServiceID: ServiceID
        };
        let request = JSON.stringify(requestObj);

        const {
            isAuthorized,
            status,
            data
        } = await OPERATOR_SELECT_BY_SERVICEID(request);

        if (!isAuthorized) LOGOUT();

        if (!status) setIsError(true);

        if (data !== 'Requested operators not found') {
            setOperators(JSON.parse(data));
        }
    };
    const ModelObj = {
        OperatorID: 0,
        ConsumerNumber: '',
        ServiceID: 0
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        SelectPendingRechargeWithFilter(values);
        setSubmitting(false);

        await callSelectData(TakeCount, SkipCount, '', '', '');
    };

    const operatorsList = operators.map(({ OperatorID, OperatorName }) => (
        <MenuItem key={OperatorName} value={OperatorID}>
            {OperatorName}
        </MenuItem>
    ));
    const PendingRechargeForm = ({
        values,
        setFieldValue,
        handleChange,
        handleSubmit
    }) => {
        return (
            <Form>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <MaterialSelect
                                label="Service"
                                name="ServiceID"
                                onCustomCallback={(name, value) => {
                                    OnOperatorChange(
                                        name,
                                        value,
                                        setFieldValue
                                    );
                                }}
                                title="Service"
                            >
                                <MenuItem key="0" value="0">
                                    All Service
                                </MenuItem>
                                {Services.map((Item) => (
                                    <MenuItem
                                        key={Item.ServiceID}
                                        value={Item.ServiceID}
                                    >
                                        {Item.ServiceName}
                                    </MenuItem>
                                ))}
                            </MaterialSelect>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <MaterialSelect
                                label="Operator"
                                name="OperatorID"
                                title="Operator"
                            >
                                <MenuItem key="0" value={0}>
                                    All Operator
                                </MenuItem>
                                {operatorsList}
                            </MaterialSelect>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <MaterialAlphaNumberField
                                label={'Consumer Number'}
                                name="ConsumerNumber"
                                // type="text"
                                placeholder={'Consumer Number'}
                                length={20}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={1} lg={1}>
                            <Box style={{ textAlign: 'center' }}>
                                <Icon
                                    className={classes.CustomImageButtonStyle}
                                    disabled={loading}
                                    classes={{
                                        root: classes.iconRoot
                                    }}
                                    onClick={(e) => {
                                        setFieldValue('IsExcelDownload', true);
                                        handleSubmit(e);
                                    }}
                                >
                                    <img
                                        alt=""
                                        className={classes.imageIcon}
                                        src={excel}
                                    />
                                </Icon>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2}>
                            <Button
                                type="submit"
                                title="submit"
                                className={classes.CustomPrimaryButtonStyle}
                                disabled={loadingOpen}
                                fullWidth
                            >
                                Search
                            </Button>
                            {loadingOpen && (
                                <CircularProgress
                                    size={24}
                                    className={classes.buttonProgress}
                                />
                            )}
                        </Grid>

                        <Grid item xs={12} sm={12} md={2} lg={2}>
                            <Button
                                type="button"
                                className={classes.CustomPrimaryButtonStyle}
                                style={{
                                    background: 'green'
                                }}
                                disabled={loadingOpen}
                                title="Success"
                                onClick={handleSuccessAllClick}
                                fullWidth
                            >
                                Success
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2}>
                            <Button
                                type="button"
                                className={classes.CustomPrimaryButtonStyle}
                                style={{
                                    background: 'red'
                                }}
                                disabled={loadingOpen}
                                title="Refund"
                                onClick={handleRefundAllClick}
                                fullWidth
                            >
                                Refund
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2}>
                            <Button
                                type="button"
                                className={classes.CustomPrimaryButtonStyle}
                                style={{
                                    background: 'blue'
                                }}
                                disabled={loadingOpen}
                                title="Shift"
                                onClick={handleShiftAllClick}
                                fullWidth
                            >
                                Shift
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Form>
        );
    };
    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={CustomContainerCloseCallback}
        >
            <FormHeader
                title="Pending Provider Recharge"
                shouldDisplayButton={false}
                buttonName=""
                link="/"
            />
            <Paper
                className={classes.PaperStyle}
                style={{ marginBottom: '10px' }}
            >
                <Formik
                    initialValues={ModelObj}
                    onSubmit={handleSubmit}
                    // validationSchema={validationSchema}
                    innerRef={formRef}
                    resetForm={ModelObj}
                    render={PendingRechargeForm}
                />
            </Paper>
            <HeaderPendingSummary headerSummary={headerSummary} />
            {PendingRechargeList}
            {isModalOpen ? APILogModal : null}
            {isAlertOpenRefund ? RefundConfirmation : null}
            {isAlertOpenRefundAll ? RefundAllConfirmation : null}
            {isAlertOpenSuccess ? SuccessConfirmation : null}
            {openProviderForShiftAll ? ShiftAllForm : null}
            {isAlertOpenSuccessAll ? SuccessAllConfirmation : null}
        </CustomContainer>
    );
};
